import { useState } from "react";
import { postAxios } from "../../util/apiCall";
import moment from "moment";

export const useChecklist5R = () => {
  const dataAuth = localStorage.getItem("auth");
  const dataUser = JSON.parse(dataAuth);

  const [loading, setLoading] = useState(false);
  const [loadingData, setLoadingData] = useState(false);
  const [loadedChecklist, setLoadedChecklist] = useState([]);
  const [loadedOperators, setLoadedOperators] = useState([]);
  const [fetchVersion, setFetchVersion] = useState(0);

  const defaultBulan = Number(moment().utcOffset(7).format("M"));
  const defaultTahun = moment().utcOffset(7).format("YYYY");

  const fetchChecklist = async ({ tim, mesin, bulan, tahun }) => {
    if (!tim || !mesin || !bulan || !tahun) return;
    try {
      setLoadingData(true);
      await postAxios(
        `${process.env.REACT_APP_ENDPOINT}/getChecklist5R`,
        { tim, mesin, bulan, tahun },
        dataUser.auth,
        (data) => {
          setLoadedChecklist(data?.checklist || []);
          setLoadedOperators(data?.operators || []);
        },
        ""
      );
    } catch (err) {
      console.log(err);
      setLoadedChecklist([]);
      setLoadedOperators([]);
    } finally {
      setLoadingData(false);
      setFetchVersion((v) => v + 1);
    }
  };

  const submitChecklist = async (payload) => {
    const body = {
      tim: payload.header.tim,
      mesin: payload.header.mesin,
      bulan: payload.header.bulan,
      tahun: payload.header.tahun,
      checklist: payload.checklist,
      operators: payload.operators,
      creator: dataUser.name,
    };

    try {
      setLoading(true);
      const res = await postAxios(
        `${process.env.REACT_APP_ENDPOINT}/inputChecklist5R`,
        body,
        dataUser.auth,
        "",
        ""
      );
      alert("Checklist berhasil dikirim.");
      return res;
    } catch (err) {
      alert("Gagal mengirim checklist, coba lagi.");
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return {
    dataUser,
    loading,
    loadingData,
    loadedChecklist,
    loadedOperators,
    fetchVersion,
    defaultBulan,
    defaultTahun,
    fetchChecklist,
    submitChecklist,
  };
};
